module.exports = __webpack_public_path__ + "img/10.1aa43e7d.png";